
import React from 'react';
import { Box, Slider, Stack, Tooltip } from '@mui/material';
import { ClassNameMap, withStyles } from '@mui/styles'
import stylesheet from '../detail-container.stylesheet';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/PriorityHigh';
import StraightIcon from '@mui/icons-material/Straight';

interface IProps {
  baselineIndex: number
  priority: number
  urgency: number
  classes: ClassNameMap
}

const GradientCircle: React.FC<IProps> = ({ baselineIndex, priority, urgency, classes }) => {
  const normalizedurgency = Math.max(0, Math.min(10, urgency));

  // Yellow (255, 255, 0) to Red (255, 0, 0)
  const getColor = (val: any) => {
    const percentage = val / 10;
    let r, g, b;
    r = 255;
    switch (val) {
      case 10:
        g = 0; b = 0; break;
      case 9:
        g = 28; b = 0; break;
      case 8:
        g = 57; b = 0; break;
      case 7:
        g = 85; b = 0; break;
      case 6:
        g = 113; b = 0; break;
      case 5:
        g = 141; b = 0; break;
      case 4:
        g = 170; b = 0; break;
      case 3:
        g = 198; b = 0; break;
      case 2:
        g = 227; b = 0; break;
      case 1:
        g = 255; b = 0; break;
    }

    return `rgb(${r}, ${g}, ${b})`;
  };

  const color = urgency === 0 ? '#e7e712ff' : getColor(normalizedurgency);

  const renderSlider = (val: any, isBaselineIndex: boolean) => {
    const valueText = (value: number) => `${value}`
    const color = isBaselineIndex ? '#A9BCDE' : '#1E4A96'

    return <Tooltip title={<small>{`Baseline ${baselineIndex} Updated ${priority}`}</small>}>
      <Slider
        min={0}
        max={15}
        getAriaValueText={valueText}
        value={val}
        // color="warning"
        sx={{
          '&.MuiSlider-root': { padding: '0px !important', width: '100%' },
          '& .MuiSlider-rail': {
            backgroundColor: '#E0DEDE !important',
            height: '0.2rem !important'
          },
          '& .MuiSlider-track': {
            border: 'none',
            backgroundColor: `${color} !important`, // Highlighted color for the difference
            height: '0.2rem !important'
          },
          '& .MuiSlider-thumb': {
            height: '0.0rem !important',
            width: '0.0rem !important',
            zIndex: 2,
            backgroundColor: `${color} !important`,
            //  border: '1px solid grey !important',
          },
        }}
      />
    </Tooltip>
  }

  return (
    <Stack direction="row" alignItems="center" justifyContent={'flex-end'} spacing={0.2} sx={{ width: '100%', height: '0.6rem !important' }}>
      <Stack direction={'column'} spacing={0.3} className={classes.fullWidth}>
        {renderSlider(baselineIndex, true)}
        {renderSlider(priority, false)}
      </Stack>

      <Tooltip title={`Urgency ${urgency}`}>
        <KeyboardDoubleArrowUpIcon
          sx={{
            color: color,
            width: '0.7rem !important',
            height: '0.7rem !important',
            padding: '0rem !important',
            verticalAlign: 'middle',
          }}
        />
      </Tooltip>
    </Stack>
  );
};

export default withStyles(stylesheet)(GradientCircle)